module.exports = __webpack_public_path__ + "assets/img/solar-panels-10.209070ac.jpg";